export const DEPARTMENT_CODES = {
    ACTUARIAL: "DEPT_ACTUARIAL",
    IT: "DEPT_IT",
    MKT_GMS: "DEPT_MKT_GMS",
    SALES_AND_MKT: "DEPT_SALES_&_MKT",
    AMS: "DEPT_AMS",
    MKT_ASST: "DEPT_MKT_ASST",
    EBAM: "DEPT_EBAM",
    MONITORING_DEPT_GMS: "DEPT_MONITORING_GMS",
    MONITORING_DEPT_ACTUARIAL: "DEPT_MONITORING_ACTUARIAL",
} as const;

export const USER_ROLES_CODES = {
    GSMH: {
        name: 'Group Sales & Marketing Head',
        code: 'ROLE_HEAD',
    },
    TL: {
        name: 'Team Leader',
        code: 'ROLE_TL',
    },
    CFE: {
        name: 'Corporate Financial Executive',
        code: 'ROLE_CFE',
    },
    marketingOfficer: {
        name: 'Marketing Officer',
        code: 'ROLE_MO',
    },
    accountsManagementServicing: {
        name: 'Accounts Management & Servicing',
        code: 'ROLE_AMS'
    },
    marketingAssistant: {
        name: 'Marketing Assistant',
        code: 'ROLE_MA',
    },
    superAdmin: {
        name: 'Super Admin',
        code: 'ROLE_SA',
    },
    analyst: {
        name: 'Analyst',
        code: 'ROLE_ANALYST',
    },
    AVP: {
        name: 'Assistant Vice President',
        code: 'ROLE_AVP',
    },
    billing: {
        name: 'Billing',
        code: 'ROLE_BILL',
    },
    departmentHead: {
        name: 'Department Head',
        code: 'ROLE_DPTH',
    },
    renewalHead: {
        name: 'Renewal Head',
        code: 'ROLE_RNW',
    },
    underWriting: {
        name: 'UnderWriting',
        code: 'ROLE_UW',
    },
    MONITORING_GMS: {
        name: 'Monitoring Corporate Financial Executive',
        code: 'MONITORING_GMS',
    },
    MONITORING_ACTUARIAL: {
        name: 'Monitoring Actuarial Officer',
        code: 'MONITORING_ACTUARIAL',
    },
} as const;